<template>
  <v-chart
    :forceFit="true"
    :height="height"
    :data="data"
    :padding="[20, 20, 95, 20]"
    :scale="scale"
  >
    <v-tooltip></v-tooltip>
    <v-axis
      :dataKey="axis1Opts.dataKey"
      :line="axis1Opts.line"
      :tickLine="axis1Opts.tickLine"
      :grid="axis1Opts.grid"
    />
    <v-axis
      :dataKey="axis2Opts.dataKey"
      :line="axis2Opts.line"
      :tickLine="axis2Opts.tickLine"
      :grid="axis2Opts.grid"
    />
    <v-legend dataKey="user" marker="circle" :offset="30" />
    <v-coord type="polar" radius="0.8" />
    <v-line position="item*score" color="user" :size="2" />
    <v-point position="item*score" color="user" :size="4" shape="circle" />
  </v-chart>
</template>

<script>
import { DataSet } from '@antv/data-set'
const axis1Opts = {
  dataKey: 'item',
  line: null,
  tickLine: null,
  grid: {
    lineStyle: {
      lineDash: null,
    },
    hideFirstLine: false,
  },
}
const axis2Opts = {
  dataKey: 'score',
  line: null,
  tickLine: null,
  grid: {
    type: 'polygon',
    lineStyle: {
      lineDash: null,
    },
  },
}

const scale = [
  {
    dataKey: 'score',
    min: 0,
    max: 100,
  },
  {
    dataKey: 'user',
    alias: '类型',
  },
]

const sourceData = [
  { item: '示例一', score: 40 },
  { item: '示例二', score: 20 },
  { item: '示例三', score: 67 },
  { item: '示例四', score: 43 },
  { item: '示例五', score: 90 },
]

export default {
  name: 'Radar',
  props: {
    height: {
      type: Number,
      default: 254,
    },
    dataSource: {
      type: Array,
      default: () => sourceData,
    },
    fields: {
      type: Array,
      default: () => [],
    },
    // 别名，需要的格式：[{field:'name',alias:'姓名'}, {field:'sex',alias:'性别'}]
    aliases: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      axis1Opts,
      axis2Opts,
      scale,
    }
  },
  computed: {
    data() {
      const dv = new DataSet.View().source(this.dataSource)
      dv.transform({
        type: 'fold',
        fields: this.fields,
        key: 'user',
        value: 'score',
      })
      let rows = dv.rows
      // 替换别名
      rows.forEach((row) => {
        for (let item of this.aliases) {
          if (item.field === row.user) {
            row.user = item.alias
            break
          }
        }
      })
      return rows
    },
  },
  // watch: {
  //   dataSource(newVal) {
  //     if (newVal.length === 0) {
  //       this.data = sourceData
  //     } else {
  //       this.data = newVal
  //     }
  //   }
  // }
}
</script>

<style scoped></style>
